import { Component, Input, Output, EventEmitter } from '@angular/core';
import { ChangeDetectionStrategy, ChangeDetectorRef } from '@angular/core';

import { languageService, languageSupport } from '@unpispas/upp-base';

/********************************/
/* STRIPE PAY BUTTON (shell)    */
/********************************/

@Component({
    selector: 'upp-stripe-pay-button',
    changeDetection: ChangeDetectionStrategy.OnPush,
    templateUrl: './upp-button.html',
    styleUrls: ['./upp-button.scss'],
})
export class UppStripePayButtonComponent extends languageSupport {
    @Input() titleKey = '@pay_now';
    @Input() subtitleKey = '';
    @Input() disabled = false;

    @Output() payClick = new EventEmitter<void>();

    readonly iconSrc = 'assets/image/stripe-icon.png';

    constructor(lang: languageService, change: ChangeDetectorRef) {
        super(lang, change);
    }

    /**
     * Emits payClick when the button is enabled.
     */
    OnPay(): void {
        if (this.disabled) {
            return;
        }
        this.payClick.emit();
    }
}
